import { render } from "./BuildingEraDisplay.vue?vue&type=template&id=b067b978"
import script from "./BuildingEraDisplay.vue?vue&type=script&lang=js"
export * from "./BuildingEraDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__